import sunitaJain from "images/consultancy_images/sunitajain.jpeg"
import monica from "images/Monica.jpeg"

export const testimonials = [
    {
        id: "deepak",
        imageSrc: "/images/deepak-jain.png",
        name: "Deepak Jain",
        subText: "Founder, Digamber Namkeen, Pipariya",
        excerpt: "I had been suffering from a persistent cough for almost four years. I tried allopathic, homeopathic, and Ayurvedic, but the relief was only temporary, and the problem kept recurring."
    },
    {
        id: "sunita",
        imageSrc: sunitaJain,
        name: "Sunita Jain",
        subText: "Sagar",
        excerpt: "Living with an autoimmune condition like HLA-B27 felt overwhelming until I found a natural path to relief. Through naturopathy, acupressure, and Sujok therapy."
    },
    {
        id: "monica",
        imageSrc: monica,
        name: "Monika Jain",
        subText: '"Mumukshu" Shahgarh',
        excerpt: "Naturopathy has been a game-changer in managing my health condition. I've found relief through natural methods that truly respect my body."
    },
    {
        id: "pragati",
        imageSrc: "/images/prgati_jain.png",
        name: "Dr. Pragati Jain",
        subText: "Founder Anuyog",
        excerpt: "With a few simple, nature-based lifestyle changes, I lost weight from 62 kg to 56 kg—completely side-effect-free. It's amazing how natural choices can improve our health."
    }
];
